import {
  NEWB_API_HOST,
  NEWB_API_KEY,
  NEWB_BASE_URL,
  NINJAS_API_HOST,
  NINJAS_API_KEY,
  NINJAS_BASE_URL,
} from "./apiConfig";

const onlySolarSystem = "?max_distance_light_year=0.00048";

export async function getPlanets() {
  let planets = [];
  await Promise.all([getNewb(), getNinjas()]).then(([newb, ninjas]) => {
    // if (!Array.isArray(newb) || !Array.isArray(ninjas)) {
    //   throw new Error("I dati ottenuti non sono nel formato atteso");
    // }
    planets = newb.map((item1) => {
      const item2 = ninjas.find((item) => item.name === item1.name);
      if (item2) {
        return {
          ...item1,
          ...item2,
        };
      } else {
        return item1;
      }
    });
  });
  return shuffle(planets);
}

//function to call the API which returns a promise
export async function getNewb() {
  const options = {
    method: "GET",
    url: NEWB_BASE_URL,
    headers: {
      "X-RapidAPI-Key": NEWB_API_KEY,
      "X-RapidAPI-Host": NEWB_API_HOST,
    },
  };

  try {
    const response = await fetch(options.url, options);
    const result = await response.json();
    return result;
  } catch (error) {
    console.error(error);
  }
}
//function to call the API which returns a promise
export async function getNinjas() {
  const options = {
    method: "GET",
    url: NINJAS_BASE_URL + onlySolarSystem,
    headers: {
      "X-RapidAPI-Key": NINJAS_API_KEY,
      "X-RapidAPI-Host": NINJAS_API_HOST,
    },
  };

  try {
    const response = await fetch(options.url, options);
    const result = await response.json();
    return result;
  } catch (error) {
    console.error(error);
  }
}

function shuffle(array) {
  let currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex > 0) {
    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
}
